import React from 'react';
import { DeepChat } from 'deep-chat-react';
import './style.css';

// Das Frontend kennt keinen API-Key mehr: Alle Anfragen gehen an das eigene Backend,
// das auf dem Server mit Claude spricht (siehe backend/index.js).
const CHAT_API_URL = process.env.REACT_APP_CHAT_API_URL || '/api/chat';

// ?embed=1: kompakte Ansicht für das Chat-Fenster auf gipam-health.com (siehe public/widget.js)
const IS_EMBED = new URLSearchParams(window.location.search).has('embed');

const styles = {
  appContainer: {
    fontFamily: "'Arial', sans-serif",
    textAlign: 'center',
    backgroundColor: '#f4f4f9',
    padding: '20px 16px',
    minHeight: '80vh',
  },
  header: { marginBottom: '20px' },
  title: { fontSize: '2.5rem', color: '#333', margin: '0.4em 0' },
  subtitle: { fontSize: '1.2rem', color: '#666', margin: 0 },
  chatContainer: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
  chatBox: {
    borderRadius: '20px',
    width: 'min(600px, 100%)',
    height: 'min(600px, 70vh)',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
    border: 'none',
  },
  disclaimer: { fontSize: '0.8rem', color: '#888', maxWidth: '600px', margin: '12px auto 0' },
  embedContainer: {
    fontFamily: "'Arial', sans-serif",
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    backgroundColor: '#fff',
  },
  // deep-chat braucht eine feste Höhe, sonst sitzt das Eingabefeld mitten im Fenster
  embedChat: { width: '100%', height: 'calc(100vh - 48px)', border: 'none', backgroundColor: '#fff' },
  embedDisclaimer: {
    fontSize: '0.7rem',
    color: '#888',
    textAlign: 'center',
    margin: 0,
    padding: '4px 12px',
    height: '48px',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

const Disclaimer = ({ style }) => (
  <p style={style}>
    Answers are generated by AI and may contain errors. Please do not enter personal or confidential data.{' '}
    <a href="https://www.gipam-health.com/privacypolicy" target="_blank" rel="noreferrer">Privacy policy</a>
  </p>
);

const Chat = ({ style }) => (
  <DeepChat
    style={style}
    introMessage={{ text: 'Hi, ask me about Real World Evidence (RWE) studies and market access strategies!' }}
    connect={{ url: CHAT_API_URL, method: 'POST' }}
    // Verlauf mitschicken, damit Rückfragen funktionieren (das Backend kürzt zusätzlich)
    requestBodyLimits={{ maxMessages: 20 }}
    errorMessages={{ displayServiceErrorMessages: true }}
    textInput={{ placeholder: { text: 'Ask a question about RWE or market access…' } }}
  />
);

const App = () =>
  IS_EMBED ? (
    <div style={styles.embedContainer}>
      <Chat style={styles.embedChat} />
      <Disclaimer style={styles.embedDisclaimer} />
    </div>
  ) : (
    <div className="App" style={styles.appContainer}>
      <header style={styles.header}>
        <h1 style={styles.title}>Welcome to GIPAM</h1>
        <p style={styles.subtitle}>Your assistant for Real World Evidence (RWE) studies and market access strategies.</p>
      </header>
      <div style={styles.chatContainer}>
        <Chat style={styles.chatBox} />
      </div>
      <Disclaimer style={styles.disclaimer} />
    </div>
  );

export default App;
